module.exports = __webpack_public_path__ + "img/crosshairs.8a8650de.svg";